import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormManager, FormRow, Grid, PageTitle, useCacheQuery } from 'gossamer-front-end';
import { Event, EventAttachment, EventAttachmentRow } from 'cb-model';
import { getFilter, getListRowLink } from 'gossamer-unified';

export const AttachmentsGrid = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const query = useCacheQuery(EventAttachment, {
    where: { and: [getFilter('event_id', 'eq', params.key)] },
  });
  const handleExit = () => navigate(getListRowLink(Event.listRowLink, params.key));
  return (
    <>
      <PageTitle verb="Update" entity={EventAttachment} />
      <FormManager
        compoundUrl="/main/~/event-attachments-grid"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: {
            type: 'update-multi',
            entity: EventAttachment,
            query,
          },
        }}
      >
        <Grid
          valuesKey="main"
          entity={EventAttachment}
          onAddRow={(data: FormRow<EventAttachmentRow>) => {
            data.event_id = parseInt(params.key);
          }}
        />
      </FormManager>
    </>
  );
};
